import { render, staticRenderFns } from "./ProjectUpdate.vue?vue&type=template&id=aceaa732&scoped=true"
import script from "./ProjectUpdate.vue?vue&type=script&lang=js"
export * from "./ProjectUpdate.vue?vue&type=script&lang=js"
import style0 from "./ProjectUpdate.vue?vue&type=style&index=0&id=aceaa732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aceaa732",
  null
  
)

export default component.exports